import { graphql } from '@/gql/graphql';
import { ChatMessageItemFragment } from './ChatMessageItem.utils';

export const GetChatMessages = graphql(`
  query GetChatMessages($id: uuid!, $limit: Int!, $cursor: timestamptz!) {
    message(
      order_by: { created_at: desc }
      where: { chat_id: { _eq: $id }, created_at: { _lt: $cursor } }
      limit: $limit
    ) @_cursorPagination {
      ...ChatMessageItem
    }
  }
`, [ChatMessageItemFragment]);
